import React from 'react'
import {useEffect, useState} from 'react'
import Button from '../Button'
import Modal from '../Modal'
import PortalMoveToKycModal from './PortalMoveToKycModal'
import PortalMoveToRfqModal from './PortalMoveToRfqModal'
import PortalProceedContractModal from './PortalProceedContractModal'
import PortalExistingLeadModal from './PortalExistingLeadModal'

const PortalNextStageCTA = ({deal}) => {
    const [ctaDisplayText, setCtaDisplayText] = useState('Next Stage')

    const [showKyc, setShowKyc] = useState(false)
    const [showRfq, setShowRfq] = useState(false)
    const [showProceedContract, setShowProceedContract] = useState(false)

    const [showExistingLead, setShowExistingLead] = useState(false)
    const [showExistingLeadCta, setShowExistingLeadCta] = useState(false)

    useEffect(() => {
        setShowExistingLeadCta(false)
        switch(deal.stage) {
            case 'Request a quote': {
                setCtaDisplayText('Review KYC')
                setShowExistingLeadCta(true)
                break
            }
            case 'Know Your Customer': {
                setCtaDisplayText('Complete KYC')
                break
            }
            case 'Contract requested': {
                setCtaDisplayText('Proceed contract')
                break
            }
            default: {

            }
        }
    }, [deal])

    const clickHandler = () => {
        switch(deal.stage) {
            case 'Request a quote': {
                setShowKyc(true)
                break
            }
            case 'Know Your Customer': {
                setShowRfq(true)
                break
            }
            case 'Contract requested': {
                setShowProceedContract(true)
                break
            }
            default: {

            }
        }
    }

    const existingLeadCtaHandler = () => {
        setShowExistingLead(true)
    }

    const didCloseKyc = () => {
        setShowKyc(false)
        window.location.reload()
    }

    const didCloseRfq = () => {
        setShowRfq(false)
        window.location.reload()
    }

    const didCloseProceedContract = () => {
        setShowProceedContract(false)
        window.location.reload()
    }

    const didCloseExistingLeadCta = () => {
        setShowExistingLead(false)
        window.location.reload()
    }

    const shouldShow = () => {
        return (deal.stage === 'Request a quote' || deal.stage === 'Know Your Customer' || deal.stage === 'Contract requested')
    }

    return (
        <>
            {shouldShow() && 
                <Button classNames={['button button--secondary']} onClick={clickHandler}>{ctaDisplayText}</Button>   
            } 
            {shouldShow() && showExistingLeadCta && 
                <Button classNames={['button button--secondary']} onClick={existingLeadCtaHandler}>Existing Client/Lead</Button>   
            }

            <Modal
                classNames={['modal__content--thin modal__content--overlap modal__content--overflowvis']}
                modalVisible={showKyc}
                closeModal={() => setShowKyc(false)}>
                <PortalMoveToKycModal closeModal={didCloseKyc} dealId={deal.id} />
            </Modal>    

            <Modal
                classNames={['modal__content--thin modal__content--overlap']}
                modalVisible={showRfq}
                closeModal={() => setShowRfq(false)}>
                <PortalMoveToRfqModal closeModal={didCloseRfq} dealId={deal.id} />
            </Modal>    

            <Modal
                classNames={['modal__content--thin modal__content--overlap']}
                modalVisible={showProceedContract}
                closeModal={() => setShowProceedContract(false)}>
                <PortalProceedContractModal closeModal={didCloseProceedContract} dealId={deal.id} dealNumPets={deal.number_of_Pets} />
            </Modal>

            <Modal
                classNames={['modal__content--thin modal__content--overlap']}
                modalVisible={showExistingLead}
                closeModal={() => setShowExistingLead(false)}>
                <PortalExistingLeadModal closeModal={didCloseExistingLeadCta} dealId={deal.id} />
            </Modal>
        </>

        
    )
}

export default PortalNextStageCTA